module.exports = __webpack_public_path__ + "static/media/attendance-report-absent.66c9996e.svg";